import React, { useState } from "react";
import {
  Container,
  Grid,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../api/auth";

const Login = () => {
  const navigate = useNavigate();
  const mutation = useLogin();
  const [utente, setUtente] = useState("");
  const [password, setPassword] = useState("");
  const [azienda, setAzienda] = useState("");

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await mutation.mutateAsync({ utente, password, azienda });
      navigate("/gestione");
    } catch (error) {
      console.error("Errore login:", error);
    }
  };

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card sx={{ width: 425, p: 2 }}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>
            Bentornato
          </Typography>
          <Typography variant="h4" align="center" gutterBottom fontWeight="bold">
            Accesso
          </Typography>

          {mutation.isError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {mutation.error?.message || "Errore durante il login"}
            </Alert>
          )}

          <form onSubmit={onSubmit}>
            <TextField
              id="utente"
              label="Nome utente"
              variant="outlined"
              fullWidth
              margin="normal"
              value={utente}
              onChange={(e) => setUtente(e.target.value)}
              required
            />

            <TextField
              id="password"
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              inputProps={{ minLength: 4 }}
            />

            <TextField
              id="azienda"
              label="Azienda"
              variant="outlined"
              fullWidth
              margin="normal"
              value={azienda}
              onChange={(e) => setAzienda(e.target.value)}
              required
            />

            <Button
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
              disabled={mutation.isPending}
              sx={{ mt: 2 }}
            >
              {mutation.isPending ? "Accesso in corso..." : "Accesso"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Login;
